/* ─── Design Tokens ──────────────────────────────── */

:root {
  --color-bg: #0a192f;
  --color-bg-card: #17335f;
  --color-bg-card-hover: #234a80;
  --color-bg-tag: #2b3a59;
  --color-bg-subtle: #0f2238;
  --color-accent: #6cb6ff;
  --color-accent-contrast: #062a4a;
  --color-text: #ccd6f6;
  --color-text-muted: #8892b0;
  --color-border: #1d3557;
  --shadow-accent: rgba(108, 182, 255, 0.45);
  --shadow-accent-hover: rgba(108, 182, 255, 0.6);
  /* Card-scoped colors: cards intentionally invert in light mode (dark cards
     on a light page), so text inside cards must not use the page-level vars */
  --color-card-text: #e2e9fb;
  --color-card-text-muted: #a7b3d6;
  --color-card-accent: #7fc0ff;
  --color-card-border: #2a4a7a;
  --color-card-tag-bg: #22406e;
  --radius-card: 8px;
  --transition-card: background-color 0.3s ease, box-shadow 0.3s ease;
  --padding-section: 5rem 2rem;
  --padding-card: 1.5rem;
}

/* Light theme — activated by ThemeContext via <html data-theme="light">.
   Same token names, so every component that uses the variables adapts for free. */
[data-theme='light'] {
  --color-bg: #dce7f5;
  --color-bg-card: #10233f;
  --color-bg-card-hover: #17335f;
  --color-bg-tag: #e4edf7;
  --color-bg-subtle: #eef4fb;
  --color-accent: #0b66c3;
  --color-accent-contrast: #eaf3fd;
  --color-text: #0f2440;
  --color-text-muted: #51648a;
  --color-border: #d6e2f0;
  --shadow-accent: rgba(11, 102, 195, 0.25);
  --shadow-accent-hover: rgba(11, 102, 195, 0.35);
  /* Card-scoped colors: cards intentionally invert in light mode (dark cards
     on a light page), so text inside cards must not use the page-level vars */
  --color-card-text: #e6eefc;
  --color-card-text-muted: #b8c6e2;
  --color-card-accent: #7fc0ff;
  --color-card-border: #2a4a7a;
  --color-card-tag-bg: #1b3a63;
}

/* ─── Base Reset ─────────────────────────────────── */

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-bg);
  color: var(--color-text);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
